import { Spin as AntSpin, type SpinProps } from 'antd'

// antd 5 Spin ignored `componentSize`, antd 6 takes `large` from ours
export const Spin = ({ size = 'medium', ...props }: SpinProps) => <AntSpin {...props} size={size} />
